import { computed, inject } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { patchState, signalStore, withComputed, withMethods, withProps, withState } from '@ngrx/signals';
import { withStorage } from '@larscom/ngrx-signals-storage';
import { storagePrefix } from '../storage.const';
import { AccountInfo } from '@azure/msal-browser';

interface UserState {
  isLoading: boolean;
  currentUser: AccountInfo | null;
}

const initialState: UserState = {
  isLoading: false,
  currentUser: null,
};

export const UserStore = signalStore(
  {providedIn: 'root', protectedState: true},
  withState(initialState),
  withProps(() => ({
    authService: inject(MsalService),
  })),
  withComputed(({...store}) => {
    const isAuthenticated = computed(() => {
      return store.currentUser != null;
    })
    return {
      isAuthenticated,
    }
  }),
  withMethods(({...store}) => ({
    setCurrentUser(user: AccountInfo | null) {
      patchState(store, {currentUser: user});
    },
    setLoadingState(loadingState: boolean) {
      patchState(store, {isLoading: loadingState});
    },
    resetState() {
      patchState(store, {...initialState});
    },
  })),
  withStorage(`${storagePrefix}user`, () => localStorage),
);
